import { UserAccessibleSection } from "../../openapi-typescript/common/user_accessible_section";
import { useAPIQuery } from "./useAPITypes";
import { useUserRole } from "../state/user";

export type FeatureCard = Pick<
  UserAccessibleSection,
  "callToActionUrl" | "featureFlag"
>;

// Every page's card, whether or not the company holds it. Admin-only cards are
// returned to admins only.
export const useFeatureCards = () => {
  const isPendingRole = useUserRole() === "pending";
  const { data, loading, sync, error } = useAPIQuery<FeatureCard[]>(
    "featureCards",
    { select: "callToActionUrl:call_to_action_url,featureFlag:feature_flag" },
    isPendingRole
  );

  return { featureCards: data ?? [], loading, sync, error };
};
